function bindPasswordToggles() {
  document.querySelectorAll("[data-password-toggle]").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      var field = toggle.closest(".auth-field");
      if (!field) {
        return;
      }
      var input = field.querySelector("input[type='password'], input[type='text']");
      if (!input) {
        return;
      }
      input.type = input.type === "password" ? "text" : "password";
    });
  });
}

// Aligné sur User#password_complexity : 12-70, majuscule, minuscule, chiffre, spécial.
function passwordRules(value) {
  return {
    length: value.length >= 12,
    upper: /[A-Z]/.test(value),
    lower: /[a-z]/.test(value),
    digit: /[0-9]/.test(value),
    special: /[!@#$%?&*()_\-=+^]/.test(value)
  };
}

function bindPasswordRules() {
  document.querySelectorAll("[data-password-form]").forEach(function (formWrap) {
    var passwordInput = formWrap.querySelector("[data-password-input], #user_password");
    var confirmInput = formWrap.querySelector("[data-password-confirmation], #user_password_confirmation");
    var submit = formWrap.querySelector("[data-password-submit]");
    var items = formWrap.querySelectorAll("[data-password-rules] [data-rule]");

    if (!passwordInput || !submit) {
      return;
    }

    function refresh() {
      var password = passwordInput.value || "";
      var confirmation = confirmInput ? confirmInput.value || "" : password;
      var rules = passwordRules(password);
      rules.match = !confirmInput || (password.length > 0 && password === confirmation);

      var allValid = true;
      items.forEach(function (item) {
        var ok = !!rules[item.getAttribute("data-rule")];
        item.classList.toggle("is-valid", ok);
        if (!ok) {
          allValid = false;
        }
      });

      submit.disabled = !allValid;
    }

    passwordInput.addEventListener("input", refresh);
    passwordInput.addEventListener("keyup", refresh);
    passwordInput.addEventListener("change", refresh);
    if (confirmInput) {
      confirmInput.addEventListener("input", refresh);
      confirmInput.addEventListener("keyup", refresh);
      confirmInput.addEventListener("change", refresh);
    }
    refresh();
  });
}

function initAuth() {
  bindPasswordToggles();
  bindPasswordRules();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAuth);
} else {
  initAuth();
}
